import { render } from "./Survey.vue?vue&type=template&id=a36989f8&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=a36989f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36989f8"]])

export default __exports__